import { render, staticRenderFns } from "./nsia_souscription.vue?vue&type=template&id=4bf5c50e&scoped=true"
import script from "./nsia_souscription.vue?vue&type=script&lang=js"
export * from "./nsia_souscription.vue?vue&type=script&lang=js"
import style0 from "./nsia_souscription.vue?vue&type=style&index=0&id=4bf5c50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5c50e",
  null
  
)

export default component.exports